module.exports = __webpack_public_path__ + "static/img/img-textcloud.0efcfd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-textcloud.png
// module id = jlsy
// module chunks = 1